import {
  toWSDateString,
  WSCard,
  WSDataItem,
  WSElement,
  WSList,
  WSSectionToolbar
} from "@wingspanhq/fe-component-library";
import React from "react";

const EMPTY_VALUE = "—";

type Props = {
  payPeriodRange: string;
  paidDate?: Date;
  employeeName: string;
  employeeAddress: string;
  onViewEmployee?: () => void;
};

export const PaystubDetailsCard: React.FC<Props> = ({
  payPeriodRange,
  paidDate,
  employeeName,
  employeeAddress,
  onViewEmployee
}) => (
  <WSElement>
    <WSSectionToolbar
      button={{ label: "View employee", onClick: onViewEmployee }}
      title="Paystub details"
    />
    <WSCard mt="M">
      <WSList gap="L">
        <WSDataItem label="Pay period" value={payPeriodRange} />
        <WSDataItem
          label="Paid date"
          value={
            paidDate ? toWSDateString(paidDate, "monthDayYear") : EMPTY_VALUE
          }
        />
        <WSDataItem label="Employee name" value={employeeName} />
        <WSDataItem label="Employee address" value={employeeAddress} />
      </WSList>
    </WSCard>
  </WSElement>
);
